import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Login(): React.JSX.Element {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { error: err } = await supabase.auth.signInWithPassword({ email, password });
      if (err) throw err;
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-dx-bg flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-3xl font-bold text-dx-text mb-1">
            ⚡ <span style={{ color: '#25D366' }}>Digitix</span>
          </div>
          <p className="text-dx-muted text-sm">Sign in to your workspace</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-dx-surface border border-dx-border rounded-2xl p-6 flex flex-col gap-4"
        >
          <div>
            <label className="text-xs font-semibold text-dx-muted mb-1.5 block">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoFocus
              className="w-full px-3.5 py-2.5 rounded-[10px] border border-dx-border bg-dx-bg text-dx-text text-[13px] outline-none box-border"
              placeholder="you@company.com"
            />
          </div>

          <div>
            <label className="text-xs font-semibold text-dx-muted mb-1.5 block">Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="w-full px-3.5 py-2.5 rounded-[10px] border border-dx-border bg-dx-bg text-dx-text text-[13px] outline-none box-border"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="px-3.5 py-2.5 rounded-[10px] bg-[rgba(255,77,106,0.08)] border border-[rgba(255,77,106,0.25)] text-dx-danger text-[13px]">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 rounded-[10px] border-none text-[13px] font-semibold text-black cursor-pointer bg-[linear-gradient(135deg,#25D366,#1BA350)] disabled:opacity-50 disabled:cursor-not-allowed mt-1"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
